import { render, staticRenderFns } from "./PatternProperties.vue?vue&type=template&id=b2afb5b8&scoped=true"
import script from "./PatternProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatternProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatternProperties.vue?vue&type=style&index=0&id=b2afb5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2afb5b8",
  null
  
)

export default component.exports